module.exports = __webpack_public_path__ + "static/puma-2-c2570716bc9322048f7ebbec470d58f0.jpg";